import { useState } from 'preact/hooks';
import { IconArrow } from './chorus';
import styles from './DisplayNameForm.module.css';

interface DisplayNameFormProps {
  onSubmit: (displayName: string) => void;
  placeholder?: string;
  submitLabel?: string;
  initial?: string;
}

export function DisplayNameForm({
  onSubmit,
  placeholder = 'Your name',
  submitLabel = 'Jump In',
  initial = '',
}: DisplayNameFormProps) {
  const [name, setName] = useState(initial);
  const [submitting, setSubmitting] = useState(false);
  const [touched, setTouched] = useState(false);
  const showError = touched && !name.trim();

  const handleSubmit = (e: Event) => {
    e.preventDefault();
    if (!name.trim() || submitting) {
      setTouched(true);
      return;
    }
    setSubmitting(true);
    onSubmit(name.trim());
  };

  return (
    <form onSubmit={handleSubmit} noValidate>
      <label htmlFor="displayName" class={styles.srOnly}>
        Display name
      </label>
      <input
        id="displayName"
        type="text"
        value={name}
        onInput={(e) => setName((e.target as HTMLInputElement).value)}
        onBlur={() => setTouched(true)}
        placeholder={placeholder}
        maxLength={100}
        required
        autoComplete="name"
        aria-invalid={showError}
        aria-describedby="displayName-error"
        class={styles.input}
      />
      <p
        id="displayName-error"
        class={styles.errorMessage}
        aria-live="polite"
        aria-atomic="true"
      >
        {showError ? 'Please enter your name' : ''}
      </p>
      <button
        type="submit"
        disabled={!name.trim() || submitting}
        class={styles.button}
      >
        {submitting ? 'Joining…' : submitLabel} <IconArrow />
      </button>
    </form>
  );
}
